import React, { useRef, useCallback, useMemo, useState } from "react";
import { Input, InputGroup, FormControl, Button } from "components/bootstrap";
import NumberUtils from "util/NumberUtils";
import "./UploadField.css";
const isFileSizeValid = (file, maxSize) => maxSize ? file.size <= maxSize : true;
const UploadField = ({
  accept = void 0,
  uploadSuccessful = void 0,
  uploadConfig = {
    maxUploadSize: 0
  },
  enableRemoval,
  currentFile = void 0,
  isLoading,
  isUploading,
  onUploadFile,
  onDeleteFile
}) => {
  const uploadRef = useRef();
  const [hasError, setHasError] = useState(false);
  const setUploadRef = useCallback((ref) => {
    uploadRef.current = ref;
  }, []);
  const onOpenBrowse = useCallback(() => {
    if (!uploadRef.current || isUploading || isLoading) {
      return;
    }
    uploadRef.current.click();
  }, [uploadRef, isUploading, isLoading]);
  const onChangeFile = useCallback(
    (e) => {
      if (uploadConfig && isFileSizeValid(e.target.files[0], uploadConfig == null ? void 0 : uploadConfig.maxUploadSize)) {
        setHasError(false);
        onUploadFile(e.target.files);
      } else {
        setHasError(true);
      }
    },
    [onUploadFile, uploadConfig]
  );
  const inputValue = useMemo(() => {
    if (currentFile) {
      return currentFile.name;
    }
    if (isLoading) {
      return "Loading file...";
    }
    if (isUploading) {
      return "Uploading file...";
    }
    return "";
  }, [currentFile, isUploading, isLoading]);
  const helpText = useMemo(() => {
    if (uploadSuccessful === true) {
      return "File uploaded successfully";
    }
    if (uploadSuccessful === false) {
      return "Something went wrong uploading the file";
    }
    if (uploadConfig == null ? void 0 : uploadConfig.maxUploadSize) {
      return `The CSV file to use. Max file size: ${NumberUtils.formatBytes(uploadConfig == null ? void 0 : uploadConfig.maxUploadSize)}`;
    }
    return " The CSV file to use.";
  }, [uploadSuccessful, uploadConfig]);
  const errorHelpText = useMemo(
    () => `The size of selected file is over the maximum allowed. (Max file size: 
      ${NumberUtils.formatBytes(uploadConfig == null ? void 0 : uploadConfig.maxUploadSize)})`,
    [uploadConfig]
  );
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "path",
      name: "path",
      label: "CSV File",
      help: hasError ? errorHelpText : helpText,
      labelClassName: "col-sm-3",
      bsStyle: hasError ? "error" : null,
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(InputGroup, null, /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(Button, { disabled: isUploading || isLoading, onClick: onOpenBrowse }, "Browse...")), /* @__PURE__ */ React.createElement(
      FormControl,
      {
        onClick: onOpenBrowse,
        type: "text",
        value: inputValue,
        onChange: () => {
        },
        tabIndex: -1,
        placeholder: "No file selected."
      }
    ), currentFile && enableRemoval && /* @__PURE__ */ React.createElement(InputGroup.Button, null, /* @__PURE__ */ React.createElement(Button, { bsStyle: "danger", onClick: onDeleteFile }, "Remove")), /* @__PURE__ */ React.createElement(
      "input",
      {
        className: "UploadField__uploadInput",
        type: "file",
        accept,
        onChange: onChangeFile,
        ref: setUploadRef
      }
    ))
  ));
};
export default UploadField;
